// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"92":"4fb0755c","195":"4fb0755c","243":"4fb0755c","288":"4fb0755c","398":"4fb0755c","601":"4fb0755c","831":"99247b81","920":"4fb0755c"}[chunkId] + ".chunk.css";
};